import { render } from "./Pins.vue?vue&type=template&id=8f086bde&lang=pug"
import script from "./Pins.vue?vue&type=script&lang=js"
export * from "./Pins.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__